// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Select from "react-select";

// const UserForm = () => {
//   const [formData, setFormData] = useState({
//     username: "",
//     usertype: "",
//     email: "",
//     password: "",
//     clubs: [],
//   });

//   const [clubs, setClubs] = useState([]);

//   // Fetch Available Clubs
//   useEffect(() => {
//     axios.get("https://320bapi.emedha.in/club/api/clubData").then((res) => {
//       setClubs(res.data.map(club => ({ value: club.clubId, label: club.clubName })));
//     });
//   }, []);

//   // Handle Input Change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     // If usertype is "DCS", select all clubs automatically
//     if (name === "usertype" && value === "DCS") {
//       setFormData({ ...formData, usertype: value, clubs: clubs.map((club) => club.value) });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };
  
//   // Handle Club Selection
//   const handleClubChange = (selectedOptions) => {
//     setFormData({ ...formData, clubs: selectedOptions.map(option => option.value) });
//   };

//   // Handle Form Submission
//   const handleSubmit = (e) => {
//     e.preventDefault();
  
//     axios.post("https://320bapi.emedha.in/auth/api/register", formData)
//       .then(res => {
//         alert(res.data.message); 
  
//         // Reset the form
//         setFormData({
//           username: "",
//           usertype: "",
//           email: "",
//           password: "",
//           clubs: []
//         });
//       })
//       .catch(err => console.error(err));
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.header}>User Registration</h2>
//       <form onSubmit={handleSubmit} style={styles.form}>
//         <input type="text" name="username" placeholder="Username" value={formData.username} onChange={handleChange} required style={styles.input} />
        
     

//         <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required style={styles.input} />
//         <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required style={styles.input} />
//         <select name="usertype" value={formData.usertype} onChange={handleChange} required style={styles.input}>
//           <option value="">Select User Type</option>
//           <option value="DCS">DCS - District Cabinet Secretary</option>
//           <option value="RC">RC - Region Chairperson</option>
//           <option value="ZC">ZC - Zone Chairperson</option>
//         </select>
//         <label style={styles.label}>Select Clubs</label>
//         <Select
//   options={clubs}
//   isMulti
//   onChange={handleClubChange}
//   value={clubs.filter((club) => formData.clubs.includes(club.value))}
//   styles={customSelectStyles}
// />


//         <button type="submit" style={styles.button}>Register</button>
//       </form>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     width: "400px",
//     margin: "40px auto",
//     padding: "20px",
//     borderRadius: "10px",
//     backgroundColor: "#001F3F", // Navy Blue
//     color: "#fff",
//     textAlign: "center",
//     boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//   },
//   header: {
//     marginBottom: "20px",
//     color: "#FF8C00", // Orange
//   },
//   form: {
//     display: "flex",
//     flexDirection: "column",
//   },
//   input: {
//     padding: "10px",
//     margin: "10px 0",
//     borderRadius: "5px",
//     border: "none",
//     fontSize: "16px",
//     outline: "none",
//     color:'black'
//   },
//   label: {
//     marginTop: "10px",
//     textAlign: "left",
//     fontWeight: "bold",
//   },
//   button: {
//     padding: "12px",
//     backgroundColor: "#FF8C00", // Orange
//     color: "#fff",
//     border: "none",
//     borderRadius: "5px",
//     cursor: "pointer",
//     fontSize: "18px",
//     marginTop: "15px",
//   },
// };

  

// export default UserForm;


import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { Table, Container, Spinner } from "react-bootstrap";

const UserForm = () => {
  const [formData, setFormData] = useState({
    username: "",
    usertype: "",
    email: "",
    password: "",
    clubs: [],
  });

  const [clubs, setClubs] = useState([]);
  const [users, setUsers] = useState([]);

  // Fetch Available Clubs
  useEffect(() => {
    axios.get("https://320bapi.emedha.in/club/api/clubData").then((res) => {
      setClubs(res.data.map(club => ({ value: club.clubId, label: club.clubName })));
    });

    // Fetch Users Data
    axios.get("http://localhost:5000/api/users").then((res) => {
      setUsers(res.data);
    }).catch(err => console.error("Error fetching users:", err));
  }, []);

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "usertype" && value === "DCS") {
      setFormData({ ...formData, usertype: value, clubs: clubs.map((club) => club.value) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  
  // Handle Club Selection
  const handleClubChange = (selectedOptions) => {
    setFormData({ ...formData, clubs: selectedOptions.map(option => option.value) });
  };

  // Handle Form Submission
  const handleSubmit = (e) => {
    e.preventDefault();
  
    axios.post("https://lionsdirectoryapi.emedha.in/auth/api/register", formData)
      .then(res => {
        alert(res.data.message); 
  
        // Reset the form
        setFormData({
          username: "",
          usertype: "",
          email: "",
          password: "",
          clubs: []
        });

        // Fetch updated user data
  
      })
      .catch(err => console.error(err));
  };

useEffect(()=>{
  axios.get("https://lionsdirectoryapi.emedha.in/member/api/api/users").then((res) => {
    setUsers(res.data);
    setLoading(false)
  });
},[])

const [loading, setLoading] = useState(true);
  

  return (
    <>
    <div style={styles.container}>
      <h2 style={styles.header}>User Registration</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input type="text" name="username" placeholder="Username" value={formData.username} onChange={handleChange} required style={styles.input} />
        <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required style={styles.input} />
        <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required style={styles.input} />
        <select name="usertype" value={formData.usertype} onChange={handleChange} required style={styles.input}>
          <option value="">Select User Type</option>
          <option value="DCS">DCS - District Cabinet Secretary</option>
          <option value="RC">RC - Region Chairperson</option>
          <option value="ZC">ZC - Zone Chairperson</option>
          <option value="CP">CP - President</option>
          <option value="CS">CS - Secretary</option>
        </select>
        <label style={styles.label}>Select Clubs</label>
        <Select
          options={clubs}
          isMulti
          onChange={handleClubChange}
          value={clubs.filter((club) => formData.clubs.includes(club.value))}
          styles={customSelectStyles}
        />
        <button type="submit" style={styles.button}>Register</button>
      </form>
      </div>
      <div style={styles.container1}>
        <h2 style={{ textAlign: "center", marginTop: "30px", color: "#FF8C00" }}>Chairpersons</h2>

        {loading ? (
          <div style={{ textAlign: "center", margin: "20px" }}>
            <Spinner animation="border" variant="warning" />
          </div>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Username</th>
                <th>User Type</th>
                <th>Email</th>
                <th>Password</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.username}</td>
                    <td>{user.usertype}</td>
                    <td>{user.email}</td>
                    <td>{user.password}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center", color: "red" }}>
                    No users found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>
    </>
  );
};

const styles = {
  container: {
    width: "500px",
    margin: "40px auto",
    padding: "20px",
    borderRadius: "10px",
    backgroundColor: "#001F3F",
    color: "#fff",
    textAlign: "center",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
  },
  container1: {
    width: "80%",
    margin: "40px auto",
    padding: "20px",
    borderRadius: "10px",
    backgroundColor: "#001F3F",
    color: "#fff",
    textAlign: "center",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
  },
  header: {
    marginBottom: "20px",
    color: "#FF8C00",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    padding: "10px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "none",
    fontSize: "16px",
    outline: "none",
    color: "black",
  },
  label: {
    marginTop: "10px",
    textAlign: "left",
    fontWeight: "bold",
  },
  button: {
    padding: "12px",
    backgroundColor: "#FF8C00",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "18px",
    marginTop: "15px",
  },
  table: {
    width: "100%",
    marginTop: "20px",
    borderCollapse: "collapse",
    backgroundColor: "#fff",
    color: "#000",
  },
  tableHeader: {
    backgroundColor: "#FF8C00",
    color: "#fff",
  },
  tableCell: {
    padding: "10px",
    border: "1px solid #ddd",
  },
};



const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#001F3F", // Navy Blue background
    borderColor: state.isFocused ? "#FF8C00" : "#001F3F", // Orange border when focused
    color: "#FFFFFF", // White text
    boxShadow: state.isFocused ? "0 0 5px #FF8C00" : "none",
    "&:hover": {
      borderColor: "#FF8C00",
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "gray", // Navy Blue dropdown background
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#FF8C00" : state.isFocused ? "#FFA54F" : "#001F3F",
    color: state.isSelected ? "#001F3F" : "#FFFFFF", // Navy text when selected, white otherwise
    "&:hover": {
      backgroundColor: "#FF8C00",
      color: "#001F3F",
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#FF8C00", // Orange tag background
    color: "#001F3F",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#001F3F", // Navy Blue text inside selected options
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#001F3F",
    "&:hover": {
      backgroundColor: "#FFA54F",
      color: "#001F3F",
    },
  }),
};

export default UserForm;

